import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './Navigation.css';
import LanguageSwitcher from './LanguageSwitcher';
import { getHomeTitle } from '../utils/getHomeTitle';
import { getHighlightedWords } from '../utils/getHighlightedWords';

const navLabels = {
  en: {
    home: 'home',
    gallery: 'gallery',
    extraInfo: 'eXtra info',
    contact: 'contact',
  },
  pl: {
    home: 'home',
    gallery: 'galeria',
    extraInfo: 'informacje',
    contact: 'kontakt',
  }
};





function getTagline(highlighted, language) {
  // Remove 'Armonia - ' or 'Armonia -' (with/without space) from the start
  if (language === 'pl') {
    return highlighted.replace(/^Armonia\s*-\s*/i, '');
  } else {
    return highlighted.replace(/^Armonia\s*-\s*/i, '');
  }
}

export default function Navigation({ language = 'en', onLanguageChange }) {

  // ... existing state
  const [open, setOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);
  const [homeTitle, setHomeTitle] = useState('Armonia');
  const [highlighted, setHighlighted] = useState('');

  useEffect(() => {
    getHomeTitle(language).then(setHomeTitle);
    getHighlightedWords(language).then(setHighlighted);
  }, [language]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Handler to change language and close burger
  const handleLanguageChange = (lang) => {
    onLanguageChange(lang);
    setOpen(false);
  };

  return (
    <nav className="navigation">
      <div className="nav-container">
        <div className="nav-logo">
          <span className="nav-logo-title">{homeTitle || 'Armonia'}</span>
          {highlighted && (
            <span className="nav-logo-tagline nav-logo-highlighted">{getTagline(highlighted, language)}</span>
          )}
        </div>
        {isMobile && (
          <button className="nav-toggle" onClick={() => setOpen(!open)} aria-label="Toggle navigation">
            <span className="hamburger"></span>
            <span className="hamburger"></span>
          </button>
        )}
        <ul className={`nav-links${open ? ' open' : ''}`}>
          <li key="home">
            <Link to="/" onClick={() => setOpen(false)}>
              {navLabels[language]?.home || navLabels.en.home}
            </Link>
          </li>
          <li key="gallery">
            <Link
              to="/gallery"
              onClick={() => {
                window.location.hash = '';
                setOpen(false);
              }}
            >
              {navLabels[language]?.gallery || navLabels.en.gallery}
            </Link>
          </li>
          <li key="extraInfo">
            <Link to="/extra-info" onClick={() => setOpen(false)}>
              {navLabels[language]?.extraInfo || navLabels.en.extraInfo}
            </Link>
          </li>
          <li key="contact">
            <Link to="/contact" onClick={() => setOpen(false)}>
              {navLabels[language]?.contact || navLabels.en.contact}
            </Link>
          </li>
          <li className="nav-language-switcher">
            <LanguageSwitcher language={language} onChange={handleLanguageChange} />
          </li>
        </ul>
      </div>
    </nav>
  );
}
